/* eslint-disable react/jsx-no-bind */
import { FunctionComponent } from 'react';
import Button from '../../../shared/components/Button/Button';
import { Configuration } from '../../../shared/models/configuration';
import ConstraintsWizardSection from '../components/ConstraintsWizardSection';
import MarketingInfluenceWizardSection from '../components/MarketingInfluenceWizardSection';
import ScopeWizardSection from '../components/ScopeWizardSection';
import SecondaryObjectivesWizardSection from '../components/SecondaryObjectivesWizardSection';
import { InventoryAllocation } from '../../../shared/models/inventoryAllocation';
import { InventoryAllocationReport } from '../../../shared/models/inventoryAllocationReport';

interface Props extends Configuration {
	inventoryAllocationId: InventoryAllocation['id'];
	reportId: InventoryAllocationReport['id'];
	defaultFilters: any[];
	isInProgress?: boolean;
	isProposal?: boolean;
	isCopyingConfiguration?: boolean;
	onCopyConfiguration: () => void;
}

const InventoryAllocationReportConfiguration: FunctionComponent<Props> = ({
	onCopyConfiguration,
	isInProgress,
	isProposal,
	isCopyingConfiguration,
	inventoryAllocationId,
	reportId,
	defaultFilters,
	...configuration
}) => {
	return (
		<div>
			<p className="text-lg text-ca-gray">
				Optimize <strong className="text-ca-purple">revenue</strong> by
				allocating inventory.
			</p>
			<ScopeWizardSection
				{...configuration.scope}
				defaultFilters={defaultFilters}
				inventoryAllocationId={inventoryAllocationId}
				reportId={reportId}
			/>
			<ConstraintsWizardSection
				inventoryAllocationId={inventoryAllocationId}
				reportId={reportId}
				constraints={configuration.constraints}
				isInProgress={isInProgress}
				isProposal={isProposal}
			/>
			{window._ENV_.REACT_APP_SECONDARY_OBJECTIVES_ENABLED && (
				<SecondaryObjectivesWizardSection
					inventoryAllocationId={inventoryAllocationId}
					reportId={reportId}
					secondaryObjectives={configuration.secondaryObjectives}
					isInProgress={isInProgress}
					isProposal={isProposal}
				/>
			)}
			{window._ENV_.REACT_APP_MARKETING_ACTIONS_ENABLED && (
				<MarketingInfluenceWizardSection
					inventoryAllocationId={inventoryAllocationId}
					reportId={reportId}
					marketingExpectations={configuration.marketingExpectations}
				/>
			)}
			<Button onClick={onCopyConfiguration} disabled={isCopyingConfiguration}>
				{isCopyingConfiguration
					? 'Creating new draft...'
					: 'Copy configuration to new draft'}
			</Button>
		</div>
	);
};

export default InventoryAllocationReportConfiguration;
